"use client";

import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

type SliderProps = React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>;

export function Slider({ className = "", ...props }: SliderProps) {
  return (
    <SliderPrimitive.Root
      className={`relative flex h-5 w-full touch-none select-none items-center ${className}`}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-[#ddd7e4]">
        <SliderPrimitive.Range className="absolute h-full bg-[#4a366d]" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full border-[3px] border-white bg-[#4a366d] shadow-md outline-none ring-offset-2 transition hover:scale-105 focus-visible:ring-2 focus-visible:ring-[#4a366d]" />
    </SliderPrimitive.Root>
  );
}
